import { render, staticRenderFns } from "./StyleViewMain.vue?vue&type=template&id=3c1f4630&"
import script from "./StyleViewMain.vue?vue&type=script&lang=js&"
export * from "./StyleViewMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports